export const employeeSearchContext = require.context(
  ".",
  true,
  /\_controller.js$/
);
